// Multivariate Dependencies
import React from 'react';
// Components
import { InteractableIconContainer } from './InteractableIconContainer';
import { DropdownStates } from '../types/DropdownStates';
import { DropdownLabels } from '../types/DropdownLabels';
// Hooks
import { useTheme } from 'styled-components';
export var ChevronIcon = function (_a) {
    var dropdownState = _a.dropdownState, isUserFocusedOnTheInput = _a.isUserFocusedOnTheInput, focusOnTheDropdownInput = _a.focusOnTheDropdownInput, searchImmediately = _a.searchImmediately, getEitherDefaultOrErrorPrimaryColour = _a.getEitherDefaultOrErrorPrimaryColour;
    var themeStyle = useTheme();
    return (React.createElement(InteractableIconContainer, { color: getEitherDefaultOrErrorPrimaryColour(isUserFocusedOnTheInput ? themeStyle.borderAccent : themeStyle.contentPrimary), gridColumn: '4', onClick: function () {
            if (dropdownState !== DropdownStates.LOCKED) {
                focusOnTheDropdownInput();
                searchImmediately('');
            }
        }, icon: 'CaretDown', ariaLabel: DropdownLabels.SHOW_DROPDOWN }));
};
//# sourceMappingURL=ChevronIcon.js.map